import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class EditEntityDuns extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            emptyDunsError: false,
            duns : this.props.dunsNumber && this.props.dunsNumber !== '00-000-0000' ? this.props.dunsNumber : ''
        };

        this.changeDuns = this.changeDuns.bind(this);
        this.validateDuns = this.validateDuns.bind(this);
        this.blurAction = this.blurAction.bind(this);
    }

    changeDuns(event) {
        let userInput             = event.target.value,
            regExFull             = /^[0-9]{2}-[0-9]{3}-[0-9]{4}$|^[0-9]{9}$/,
            regExPartial          = /^[0-9]{2}-[0-9]{7}$|^[0-9]{5}-[0-9]{4}$/,
            isInputValid          = regExFull.test(userInput),
            isInputPartiallyValid = regExPartial.test(userInput);

        if (isInputValid && userInput.length === 9 || isInputPartiallyValid && userInput.length > 9) {
            userInput = userInput.replace('-', '');
            userInput = userInput.substr(0, 2) + '-' + userInput.substr(2, 3) + '-' + userInput.substr(5);
        }

        this.setState({duns: userInput}, this.validateDuns);
    }

    validateDuns(showErrorMessage = true) {
        let regEx      = /^[0-9]{2}-[0-9]{3}-[0-9]{4}$/,
            validInput = regEx.test(this.state.duns);

        if (showErrorMessage) {
            this.setState({emptyDunsError: !validInput});
        }

        return validInput;
    }

    blurAction() {
        if (!this.state.emptyDunsError && this.props.dunsNumber !== this.state.duns && this.state.duns) {
            this.props.onBlur("dunsNumber", this.state.duns);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dunsNumber !== this.props.dunsNumber) {
            this.setState({duns: nextProps.dunsNumber})
        }
    }


    render() {

        return (
            <div className="edit-third-party__about__input-group">
                <div className="row-label">
                    <label htmlFor="edit-third-party__about__duns">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.dunsLabel" />
                        {this.props.isRequiredField ? <span className="required-field-star" /> : null}
                    </label>
                </div>
                <input type="text"
                       maxLength="11"
                       id="edit-third-party__about__duns"
                       name="dunsNumber"
                       placeholder="00-000-0000"
                       value={this.state.duns}
                       onChange={this.changeDuns}
                       onBlur={this.blurAction}
                />
                <div className={'edit-third-party__about__empty-duns-error' +
                (this.state.emptyDunsError ? '' : ' hidden')}>
                    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.dunsTip" />
                </div>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityDuns.jsx